var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.432 13.375c.163 0 .295.13.295.292v8.166c0 .645-.529 1.167-1.182 1.167h-7.09a1.174 1.174 0 01-1.182-1.167v-8.166c0-.161.132-.292.295-.292zm-5.91 1.896a.44.44 0 00-.442.437v5.25a.44.44 0 00.443.438.44.44 0 00.443-.438v-5.25a.44.44 0 00-.443-.437zm2.955 0a.44.44 0 00-.443.437v5.25a.44.44 0 00.443.438.44.44 0 00.443-.438v-5.25a.44.44 0 00-.443-.437zm0-6.271c.816 0 1.478.653 1.478 1.458v.73c0 .08.066.145.147.145h2.807c.326 0 .591.262.591.584a.587.587 0 01-.59.583H10.09a.587.587 0 01-.59-.583c0-.322.265-.584.59-.584h2.808a.145.145 0 00.148-.146v-.729c0-.805.66-1.458 1.477-1.458zm0 1.167h-2.954a.294.294 0 00-.296.291v.73c0 .08.066.145.148.145h3.25a.147.147 0 00.148-.146v-.729a.294.294 0 00-.296-.291z",
    fill: "#0D0C21",
    fillRule: "evenodd"
  })));
};

export default SvgTrash;